import { requestHelpers } from '../../../helpers';

const actions = {
    GET_CURRENT_WEBINAR: 'GET_CURRENT_WEBINAR',
    SET_CURRENT_WEBINAR: 'SET_CURRENT_WEBINAR',
    GET_WEBINARS: 'GET_WEBINARS',
    SET_WEBINARS: 'SET_WEBINARS',
    GET_WEBINAR_LOCATIONS: 'GET_WEBINAR_LOCATIONS',
    SET_WEBINAR_LOCATIONS: 'SET_WEBINAR_LOCATIONS',
    GET_CURRENT_WEBINAR_MODULES: 'GET_CURRENT_WEBINAR_MODULES',
    SET_CURRENT_WEBINAR_MODULES: 'SET_CURRENT_WEBINAR_MODULES',
};

function getCurrentWebinar( webinarId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_WEBINAR,
            webinarId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/webinars/${ webinarId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_WEBINAR,
                    webinar: response.data,
                } );
            } );
    }
}

function getCurrentWebinarModules( webinarId, seriesId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_WEBINAR_MODULES,
            webinarId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/webinars/${ webinarId }/series/${ seriesId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_WEBINAR_MODULES,
                    modules: response.data[0].modules,
                } );
            } );
    }
}

function getWebinars( page ) {

    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_WEBINARS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/training/webinars', { page } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_WEBINARS,
                    webinars: response.data,
                    pagination: response.meta,
                } );
            } );
    }
}

module.exports = {
    getCurrentWebinar,
    getWebinars,
    getCurrentWebinarModules,
    actions
};



// WEBPACK FOOTER //
// src/client/actions/training/webinars/webinars.js